import { Screen } from '~/screens/Branches';

export const Branches: React.FC = () => <Screen />;
